import React, { useState } from 'react';
import GreetingsAdmin from './GreetingsAdmin';
import CareersAdmin from './CareersAdmin';
import ApplicationsAdmin from './ApplicationsAdmin';
import './AdminPanel.css'; // Custom styles for the Admin Panel

const AdminPanel = () => {
    const [greetings, setGreetings] = useState([]);
    const [careers, setCareers] = useState([]);
    const [applications] = useState([
        {
            name: 'John Doe',
            email: 'john@example.com',
            resumePath: '/uploads/john-resume.pdf',
        },
    ]);

    const handleLogout = () => {
        // Handle logout functionality (clear auth tokens, redirect, etc.)
        window.location.href = '/login'; // Redirect to login page
    };

    return (
        <div className="admin-panel">
            <header className="admin-header">
                <h1>Admin Panel</h1>
                <button className="logout-btn" onClick={handleLogout}>
                    Logout
                </button>
            </header>
            <main className="admin-content">
                <section className="admin-section">
                    <GreetingsAdmin greetings={greetings} setGreetings={setGreetings} />
                </section>
                <section className="admin-section">
                    <CareersAdmin careers={careers} setCareers={setCareers} />
                </section>
                <section className="admin-section">
                    <ApplicationsAdmin applications={applications} />
                </section>
            </main>
        </div>
    );
};

export default AdminPanel;
